import { Badge } from 'Components/_theme'

import { Heading } from '../Heading/Heading'
import { PRIMARY_BADGE_COLORS, SECONDARY_BADGE_COLORS } from './Badge.constants'
import { BadgeColor } from './Badge.types'

export const BadgePresentation = () => {
  /* *** Primary Badge *** */

  const renderPrimaryBadges = () =>
    PRIMARY_BADGE_COLORS.map(color => (
      <Badge className="ms-6" color={color as BadgeColor}>
        Primary {color}
      </Badge>
    ))
  /* *** Primary Rounded Badge *** */

  const renderPrimaryRoundedBadges = () =>
    PRIMARY_BADGE_COLORS.map(color => (
      <Badge className="ms-6" color={color as BadgeColor} rounded>
        Primary {color}
      </Badge>
    ))

  /* *** Primary Outline Badge *** */

  const renderPrimaryOutlineBadges = () =>
    PRIMARY_BADGE_COLORS.map(color => (
      <Badge className="ms-6" color={color as BadgeColor} variant="outline">
        Primary {color}
      </Badge>
    ))
  /* *** Primary Rounded Outline Badge *** */

  const renderPrimaryOutlineRoundedBadges = () =>
    PRIMARY_BADGE_COLORS.map(color => (
      <Badge
        className="ms-6"
        color={color as BadgeColor}
        rounded
        variant="outline"
      >
        Primary {color}
      </Badge>
    ))
  /* *** Secondary Badge *** */

  const renderSecondaryBadges = () =>
    SECONDARY_BADGE_COLORS.map(color => (
      <Badge className="ms-6" color={color as BadgeColor} variant="secondary">
        Primary {color}
      </Badge>
    ))

  /* *** Secondary Rounded Badge *** */

  const renderSecondaryRoundedBadges = () =>
    SECONDARY_BADGE_COLORS.map(color => (
      <Badge
        className="ms-6"
        color={color as BadgeColor}
        rounded
        variant="secondary"
      >
        Primary {color}
      </Badge>
    ))

  return (
    <div>
      <Heading size={4}> Badges:</Heading>
      <Heading size={6}> Primary Buttons:</Heading>

      {/* *** Primary Badge *** */}

      <div className="d-flex pt-4 ms-n4">{renderPrimaryBadges()}</div>

      {/* *** Primary Rounded Badge *** */}

      <div className="d-flex pt-4 ms-n4">{renderPrimaryRoundedBadges()}</div>

      {/* *** Primary Outline Badge *** */}

      <div className="d-flex pt-4 ms-n4">{renderPrimaryOutlineBadges()}</div>

      {/* *** Primary Rounded Outline Badge *** */}

      <div className="d-flex pt-4 ms-n4">
        {renderPrimaryOutlineRoundedBadges()}
      </div>

      <hr className="hr-presentation" />

      <Heading className="pt-4" size={6}>
        Secondary Buttons:
      </Heading>

      {/* *** Secondary Badge *** */}

      <div className="d-flex pt-4 ms-n4">{renderSecondaryBadges()}</div>

      {/* *** Secondary  Rounded Badge *** */}

      <div className="d-flex pt-4 ms-n4">{renderSecondaryRoundedBadges()}</div>
    </div>
  )
}
